import { gql } from '@apollo/client';
import { Button, Form, Input, Select, Space } from 'antd';
import { useMutation } from 'hooks/apollo';
import React from 'react';
import useDataSource from 'hooks/useDataSource';
import useGlobalContext from 'hooks/useGlobalContext';
import globalMessages from 'translations/messages';

import Page from 'components/Page';
import { PeriodType } from 'shared/services/prisma/types';
import LicenseTag from 'components/LicenseTag';
import FormLabel from 'components/FormLabel';
import useFormatMessage from 'hooks/useFormatMessage';
import messages from '../messages';

const FIELDS = `
  id
  checkInterval
  checkReportEmail
`;

const extraFields = `
  website {
    ${FIELDS}
  }
`;

const UPDATE_WEBSITE = gql`
  mutation($id: ID!, $input: WebsiteInput!) {
    updateWebsite(id: $id, input: $input) {
      ${FIELDS}
    }
  }
`;

const BrokenLinksSettings = () => {
  const { dataSource, loading, getDataSourceLicenseSetting } = useDataSource({ extraFields });
  const [updateWebsite, { loading: updating }] = useMutation(UPDATE_WEBSITE);
  const { message } = useGlobalContext();
  const $t = useFormatMessage();

  const onSubmit = async (values) => {
    try {
      updateWebsite({
        variables: {
          id: dataSource?.website.id,
          input: {
            checkInterval: values.checkInterval || null,
            checkReportEmail: values.checkReportEmail || null,
          },
        },
      });
      message.success($t(globalMessages.successfullFormFeedback));
    } catch (e) {
      console.log(e);
      message.error($t(globalMessages.errorFormFeedback));
    }
  };

  const hasWeeklyOption = getDataSourceLicenseSetting('brokenLinksWeeklyCheck');
  const hasMonthlyOption = getDataSourceLicenseSetting('brokenLinksMonthlyCheck');

  const checkIntervalOptions = [
    { value: '', label: 'Never' },
    { value: PeriodType.Week,
      label: (
        <Space>
          Weekly
          {!hasWeeklyOption && <LicenseTag setting="brokenLinksWeeklyCheck" showTooltip popoverProps={{ placement: 'left' }} />}
        </Space>
      ),
      disabled: !hasWeeklyOption },
    { value: PeriodType.Month,
      label: (
        <Space>
          Monthly
          {!hasMonthlyOption && <LicenseTag setting="brokenLinksMonthlyCheck" showTooltip popoverProps={{ placement: 'left' }} />}
        </Space>
      ),
      disabled: !hasMonthlyOption },
  ];

  const initialValues = {
    checkInterval: dataSource?.website?.checkInterval || '',
    checkReportEmail: dataSource?.website?.checkReportEmail || '',
  };

  return (
    <Page loading={loading}>
      <Page.Content title="Broken links">
        <Form onFinish={onSubmit} initialValues={initialValues} layout="vertical">
          <Form.Item name="checkInterval" label="Automatically check for broken links">
            <Select options={checkIntervalOptions} />
          </Form.Item>
          <Form.Item name="checkReportEmail" label={<FormLabel label={messages.brokenLinkEmail} description={messages.brokenLinkEmailDescription} />} rules={[{ required: true, message: 'Required' }]}>
            <Input />
          </Form.Item>
          <Page.Footer>
            <Button type="primary" htmlType="submit" loading={updating}>Save</Button>
          </Page.Footer>
        </Form>
      </Page.Content>
    </Page>
  );
};

export default BrokenLinksSettings;
